import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { PlanningCompleteDto, ProgrammePlanningDto } from '@/shared/types/planning'

export const planningApi = {
  getByEtudiantId: (etudiantId: number) =>
    api
      .get<ApiResponse<PlanningCompleteDto>>(`/api/planning/etudiant/${etudiantId}`)
      .then((r) => r.data.data),

  updateProgrammePlanning: (id: number, jourDeclenchement: number) =>
    api
      .put<ApiResponse<ProgrammePlanningDto>>(`/api/programme-planning/${id}`, { jourDeclenchement })
      .then((r) => r.data.data),

  deactivateProgrammePlanning: (id: number) =>
    api
      .put<ApiResponse<ProgrammePlanningDto>>(`/api/programme-planning/${id}/desactivate`)
      .then((r) => r.data.data),

  reactivateProgrammePlanning: (id: number) =>
    api
      .put<ApiResponse<ProgrammePlanningDto>>(`/api/programme-planning/${id}/reactivate`)
      .then((r) => r.data.data),

  updateLangueStart: (etudiantMatiereId: number, debutLundi: boolean) =>
    api
      .put<ApiResponse<unknown>>(`/api/etudiant-matieres/${etudiantMatiereId}`, { debutLundi })
      .then((r) => r.data),
}
